module.exports = __webpack_public_path__ + "img/emoji_18.1ea4b3b4.png";